import React from "react";
import { UxIcon, UxIconEnum, UxSizeEnum, UxSizeExtendedEnum } from "@imaginelearning/mps-ux-component-library";
import { ISubAssessment } from "../types";

interface IFormativeNotActiveProps {
  assessment: ISubAssessment;
}

function FormativeNotActive(props: IFormativeNotActiveProps) {
  const icon = props.assessment.status === "Completed" ? UxIconEnum.CHECK_CIRCLE : UxIconEnum.LOCK_ALT;
  return (
    <div className="formative-bubble notinprogress">
      <div className="card-body visual-action-body container h-100 rounded-circle animation align-after border-ease card-body">
        <div className="mpng-ux-visual-action-content align-items-center flex-column justify-content-center text-center text-white d-flex h-100 m-0">
          <div className="mb-4">
            <h2
              className="card-title visual-action-title m-0 truncate-lines text-lg card-title"
              title={props.assessment.name}
            >
              {props.assessment.name}
            </h2>
          </div>
          {props.assessment.status === "Completed" ? (
            <button
              type="button"
              disabled={true}
              aria-label="button"
              tabIndex={0}
              className="rounded-pill btn btn-lg btn-success"
            >
              <UxIcon icon={icon} size={UxSizeExtendedEnum.X2} className="formative-coursemap-icon" />
            </button>
          ) : (
            <button
              type="button"
              disabled={true}
              aria-label="button"
              tabIndex={0}
              className="rounded-pill text-white btn btn-black btn-lg"
            >
              <UxIcon icon={icon} size={UxSizeEnum.MEDIUM} className="formative-coursemap-icon" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default FormativeNotActive;
